import { Country } from "./country.model";

export class State {
    id: number;
    name: string;
    shortName: string;
    country?: Country;
}